import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../static/common/flow.png';

const _withScopeId = n => (_pushScopeId("data-v-cca8da62"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "school-run-box header-top"
};
const _hoisted_2 = {
  class: "school-run-box-content"
};
const _hoisted_3 = {
  class: "content-1-box common-flex-direction-center"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-title wow fadeInUp"
}, "多种校园跑腿服务模式", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "common-des wow fadeInUp",
  "data-wow-delay": "0.2s"
}, "满足各种跑腿场景，开启更轻松的跑腿生活方式", -1));

const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = ["data-wow-delay"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "item-bottom"
};
const _hoisted_10 = {
  class: "item-title"
};
const _hoisted_11 = {
  class: "item-des-list-item"
};
const _hoisted_12 = {
  class: "content-5-box common-flex-direction-center"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title wow slideInDown"
}, "校园跑腿业务服务流程", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "des wow slideInDown"
}, "每天跑单，看各色的人和故事", -1));

const _hoisted_15 = {
  class: "content"
};
const _hoisted_16 = ["data-wow-delay"];
const _hoisted_17 = ["src", "alt"];
const _hoisted_18 = {
  class: "item-title"
};

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "step-image-box wow slideInLeft"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_0
})], -1));

const _hoisted_20 = {
  class: "content"
};
const _hoisted_21 = ["data-wow-delay"];
const _hoisted_22 = {
  class: "item-des"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");

  const _component_SchoolHeader = _resolveComponent("SchoolHeader");

  const _component_SchoolType = _resolveComponent("SchoolType");

  const _component_EachSideShow = _resolveComponent("EachSideShow");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Header, {
    activeIndex: 3,
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"]), _createVNode(_component_SchoolHeader, {
    type: 2
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content1List, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow fadeInUp",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "item-image",
      src: item.image
    }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.desList, (des, dIndex) => {
      return _openBlock(), _createElementBlock("div", {
        class: "item-des-list",
        key: dIndex
      }, [_createElementVNode("div", _hoisted_11, _toDisplayString(des), 1)]);
    }), 128))])], 8, _hoisted_7);
  }), 128))])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _hoisted_14, _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content5List, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow flipInY",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("img", {
      class: "item-image",
      src: item.image,
      alt: item.title
    }, null, 8, _hoisted_17), _createElementVNode("div", _hoisted_18, _toDisplayString(item.title), 1)], 8, _hoisted_16);
  }), 128))]), _hoisted_19, _createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content5List, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item wow flipInY",
      "data-wow-delay": index * 0.1 + 's',
      key: index
    }, [_createElementVNode("div", _hoisted_22, _toDisplayString(item.des), 1)], 8, _hoisted_21);
  }), 128))])]), _createVNode(_component_SchoolType, {
    type: 2
  }), _createVNode(_component_EachSideShow)]), _createVNode(_component_Footer, {
    siteInfo: $data.siteInfo
  }, null, 8, ["siteInfo"])]);
}